import { CartService } from './cart.service';
import { CommonService } from './../../shared/services/common.service';
import { CodeFamily, IdentificationNameGrouped, TranslationAttributeImageKey } from './../interfaces/product.interface';
import { HttpClient } from '@angular/common/http';
import { Ticket } from './../interfaces/ticket.interface';
import { Injectable } from '@angular/core';

import * as BASE64_IMAGE from '../../shared/constant/base64images.js';
import * as USEFUL_INFO from '../../shared/constant/ticketText.js';

import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { IAttributeInfoFromItemParams, MediaApiService, MediaFilters } from '../../shared/services/media-api.service';
import { Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { S1UIService } from '../../s1/services/s1-ui.service';
import { LoggingService } from './log.service';
import { CoveredPipe } from '../../shared/pipes/covered.pipe';
import { ProductService } from './product.service';

declare var require: any;

const pdfMake = require('pdfmake/build/pdfmake.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const JsBarcode = require('jsbarcode');
const { PDF417 } = require("pdf417-generator");

enum BarcCodeType {
  PDF417 = "PDF417"
}

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  ticketList: Ticket[] = [];
  ticketListLenght = 0;

  xMargin: number = 20;

  pdf: any = {
    info: {
      title: 'ticket',
      author: 'SACBO'
    },
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [20, 20],
    content: [],
    images: {
      header: BASE64_IMAGE.header,
      vip_card_img: BASE64_IMAGE.vip_card_img,
      batt_volo_img: BASE64_IMAGE.batt_volo_img,
    },
    styles: {
      header: {
        fontSize: 16,
        bold: true
      },
      subheader: {
        fontSize: 15,
        bold: true
      },
      textBold: {
        bold: true,
        fontSize: 10,
        alignment: 'justify'
      },
      textUnderline: {
        decoration: 'underline',
        fontSize: 10,
        alignment: 'justify'
      },
      text: {
        alignment: 'justify',
        fontSize: 10,
      },
      link: {
        alignment: 'justify',
        color: '#85bedc',
        fontSize: 10,
      },
      bold: {
        bold: true
      },
      quote: {
        italics: true
      },
      small: {
        fontSize: 8
      }
    }
  };

  productsStrings: any;

  ticketSub: Subscription;

  locale = "IT-it";
  timezone = {timeZone: 'Europe/Rome'};

  suffixName = "";

  /** Memoized per-language static PDF media (header/VIP card/battery) — cleared on lang change */
  private staticMediaCache = new Map<string, Promise<string | ArrayBuffer>>();

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private cartService: CartService,
    private translate: TranslateService,
    private mediaApiService: MediaApiService,
    private ui: S1UIService,
    private logger: LoggingService,
    private coveredPipe: CoveredPipe,
    private productService: ProductService
  ) {
    this.http.get('./assets/product-const/translated-strings.json').subscribe(resp => {
      this.productsStrings = resp;
    });

    this.locale = this.translate.currentLang == "en" ? "EN-gb" : "IT-it";

    this.translate.onLangChange.subscribe(() => this.staticMediaCache.clear());

  }

  generatePdf() {
    if (!this.ticketSub) {
      this.ticketSub = this.cartService.getTicketList().subscribe(res => {
        this.ticketList = res ? res : [];
        this.ticketListLenght = this.ticketList.length;
        this.getBannerAndCreatePdf();
      });
    }
  }

  /** On PDF creation the amount of paragraphs to be printed are defined in ticketText.js */
  async constructPdf(banner_pie: string) {
    this.pdf.images.header = await this.readMediaCached(this.translate.currentLang, { key: 'HEADER_PDF_TICKET', type: '' });
    this.pdf.images.vip_card_img = await this.readMediaCached(this.translate.currentLang, { key: 'VIP_CARD_IMG', type: '' });
    this.pdf.images.batt_volo_img = await this.readMediaCached(this.translate.currentLang, { key: 'BATT_VOLO_IMG', type: '' });

    // per gestire immaginetta vipCard
    let img2Cols = '';
    let addTextInfo = '';
    let preTextParagraph = '';
    let postTextParagraph = '';
    let numPages = 1;
    let viewPassengers, viewTypeCard = false;
    this.pdf.content = [];

    let familyImg: any = '';
    // let familyName: string = '';
    let usefulInfo: any[] = [];
    for (let i = 0; i < this.ticketList.length; i++) {

      // Reset variabili
      img2Cols = '';
      addTextInfo = '';
      preTextParagraph = '';
      postTextParagraph = '';
      viewPassengers = false;
      viewTypeCard = false;
      familyImg = '';
      numPages = 1;

      usefulInfo = [];

      const ticket: Ticket = this.ticketList[i];

      const blob = await this.getProductImage(ticket.additionalInfoProduct.id, TranslationAttributeImageKey.IMG_PRODUCT_LOGO).toPromise();

      let imgProd: string;
      
      if (blob) {
        imgProd = await this.imageFromBlob(blob).toPromise();
      }

      let comboTicketCode = "";

      /* SET VARIABLES */
      switch (ticket.codeFamily) {
        case CodeFamily.FAST_TRACK:
          ticket.additionalInfo.withdrawalData = undefined;
          ticket.additionalInfo.accountHolder = undefined;
          ticket.additionalInfo.nameLeader = undefined;
          ticket.additionalInfo.date = undefined;
          // familyImg = BASE64_IMAGE.fast_track;
          // familyName = 'Fast Track';
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.fast_track , this.productsStrings , this.translate.currentLang , CodeFamily.FAST_TRACK);
          break;
        case CodeFamily.VIP_LOUNGE:
          preTextParagraph = this.productsStrings[this.translate.currentLang][ticket.codeFamily]['extra-service'];
          // familyImg = BASE64_IMAGE.vip_lounge;
          // familyName = 'Vip-Lounge';
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.vip_lounge , this.productsStrings , this.translate.currentLang , CodeFamily.VIP_LOUNGE);
          // se il prod. VIP Lounge è un HElloSky, sostituisco i valori all'interno
          if (ticket.additionalInfoProduct.identificationName === IdentificationNameGrouped.HELLO_SKY_LOUNGE) {
            numPages = 2;
            preTextParagraph = this.productsStrings[this.translate.currentLang][CodeFamily.VIP_LOUNGE_HELLOSKY_LOUNGE]['extra-service'];
            // preTextParagraph = preTextParagraph.replace(IdentificationNameGrouped.VIP_LOUNGE,IdentificationNameGrouped.HELLO_SKY_LOUNGE);
           usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.vip_lounge , this.productsStrings , this.translate.currentLang , CodeFamily.VIP_LOUNGE_HELLOSKY_LOUNGE);
          }
          // se il prod. VIP Lounge è un HelloSkyDoccia, sostituisco i valori all'interno
          if (ticket.additionalInfoProduct.identificationName === IdentificationNameGrouped.HELLO_SKY_LOUNGE_DOCCIA) {
            numPages = 2;
            preTextParagraph = this.productsStrings[this.translate.currentLang][CodeFamily.VIP_LOUNGE_HELLOSKY_LOUNGE_DOCCIA]['extra-service']; // preTextParagraph.replace(IdentificationNameGrouped.VIP_LOUNGE,IdentificationNameGrouped.HELLO_SKY_LOUNGE_DOCCIA);
            usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.vip_lounge , this.productsStrings , this.translate.currentLang , CodeFamily.VIP_LOUNGE_HELLOSKY_LOUNGE_DOCCIA);
            ticket.name = this.productsStrings[this.translate.currentLang][CodeFamily.VIP_LOUNGE_HELLOSKY_LOUNGE_DOCCIA]['name'];
          }
          break;
        case CodeFamily.VIP_CARD:
          preTextParagraph = ticket.additionalInfo.withdrawalData !== undefined ? '' : this.productsStrings[this.translate.currentLang].generic.ti_avviseremo;
          viewTypeCard = true;
          img2Cols = 'vip_card_img';
          // familyImg = BASE64_IMAGE.vip_card;
          // familyName = 'Vip-Card';
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.vip_card , this.productsStrings , this.translate.currentLang , CodeFamily.VIP_CARD);
          break;
        case CodeFamily.HONOR_CARD:
            preTextParagraph = ticket.additionalInfo.withdrawalData !== undefined ? '' : this.productsStrings[this.translate.currentLang].generic.ti_avviseremo;
            viewTypeCard = true;
            usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.honor_card , this.productsStrings , this.translate.currentLang , CodeFamily.HONOR_CARD);
            break;
        case CodeFamily.BGY_GO:
          addTextInfo = this.productsStrings[this.translate.currentLang].generic.seleziona_bgygo;
          viewPassengers = true;
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.bgy_go , this.productsStrings , this.translate.currentLang , CodeFamily.BGY_GO);
          break;
        case CodeFamily.BGY_TOP:
          addTextInfo = this.productsStrings[this.translate.currentLang].generic.seleziona_bgytop;
          viewPassengers = true;
          // familyImg = BASE64_IMAGE.bgy_top;
          // familyName = 'BGY-Top';
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.bgy_top , this.productsStrings , this.translate.currentLang , CodeFamily.BGY_TOP);
          break;
        case CodeFamily.FAST_TRACK_PLUS:
          // familyImg = BASE64_IMAGE.fast_track_plus;
          // familyName = 'Fast Track Plus';
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.fast_track_plus , this.productsStrings , this.translate.currentLang , CodeFamily.FAST_TRACK_PLUS);
          break;
        case CodeFamily.BATT_VOLO:
          // preTextParagraph = ticket.additionalInfo.withdrawalData !== undefined ? '' : this.productsStrings[this.translate.currentLang].generic.ti_avviseremo;
          viewTypeCard = true;
          img2Cols = 'batt_volo_img';
          // familyImg = BASE64_IMAGE.vip_card;
          // familyName = 'Vip-Card';
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.batt_volo , this.productsStrings , this.translate.currentLang , CodeFamily.BATT_VOLO);
          break;

        case CodeFamily.COMBO:
          // preTextParagraph = ticket.additionalInfo.withdrawalData !== undefined ? '' : this.productsStrings[this.translate.currentLang].generic.ti_avviseremo;
          viewTypeCard = true;
          viewPassengers = true;

          let comboTicketCode = "";
          
          //  I biglietti combo hanno descrizione diverse per ogni tipo, inoltre durante lo sviluppo è stato cambiato il codice dei prodotti, per retrocompatibilità si controlla anche il vecchia valore dei codici
          if (ticket.additionalInfoProduct.itemCode === 'CM0001' || ticket.additionalInfoProduct.itemCode === 'CMP001' || ticket.additionalInfoProduct.itemCode === 'CMP003' || ticket.additionalInfoProduct.itemCode === 'CMP005' || ticket.additionalInfoProduct.itemCode === 'CMP007' || ticket.additionalInfoProduct.itemCode === 'CMP009' || ticket.additionalInfoProduct.itemCode === 'CMP011' || ticket.additionalInfoProduct.itemCode === 'PR001') {
            comboTicketCode = "1";
          } else if (ticket.additionalInfoProduct.itemCode === 'CM0002' || ticket.additionalInfoProduct.itemCode === 'CMP002' || ticket.additionalInfoProduct.itemCode === 'CMP004' || ticket.additionalInfoProduct.itemCode === 'CMP006' || ticket.additionalInfoProduct.itemCode === 'CMP008' || ticket.additionalInfoProduct.itemCode === 'CMP010' || ticket.additionalInfoProduct.itemCode === 'CMP012' || ticket.additionalInfoProduct.itemCode === 'PR002') {
            comboTicketCode = "2";
          } else if (ticket.additionalInfoProduct.itemCode === 'CP0071' || ticket.additionalInfoProduct.itemCode === 'CMP013' || ticket.additionalInfoProduct.itemCode === 'CMP014' || ticket.additionalInfoProduct.itemCode === 'CMP015' || ticket.additionalInfoProduct.itemCode === 'CMP016') {
            comboTicketCode = "3";
          }

          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.combo , this.productsStrings , this.translate.currentLang , CodeFamily.COMBO + "_" + comboTicketCode);
          break;

        case CodeFamily.PARK:
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.park , this.productsStrings , this.translate.currentLang , CodeFamily.PARK);
          break;

        case CodeFamily.PORTERAGGIO:
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.porteraggio , this.productsStrings , this.translate.currentLang , CodeFamily.PORTERAGGIO); 
        break;

        case CodeFamily.DIF:
          usefulInfo = this.commonService.getProductTranslatedString( USEFUL_INFO.dif , this.productsStrings , this.translate.currentLang , CodeFamily.DIF);
        break;


        default:
          usefulInfo = [];
          break;
      }
       
      /** ----------------------------- MODALITA ANDREA + EROS -----------------------------*/

      /** Recupero  immagine prodotto, appena si inseriscono img prodotti va rimesso!*/
      familyImg = imgProd; // BASE64_IMAGE[ticket.additionalInfoProduct.itemCode];

      /* Header con Logo Sacbo*/
      this.pdf.content.push({ image: 'header', width: 555, margin: [0, 0, 0, 20] });

      /* Header con Immagine prodotto */
      if (familyImg) {
        this.pdf.content.push({ image: familyImg, width: 100, margin: [0, 0, this.xMargin, 20], alignment: 'right' });
      }
      
      /* Area testo dinamico 1*/
      this.pdf.content.push(usefulInfo);

      /* Area A con 2 colonne */
      this.insert2ColsData(ticket, i, img2Cols, viewPassengers, viewTypeCard);

      /* Area con testi finali*/
      this.insertRichiestaInfo(preTextParagraph, addTextInfo, postTextParagraph);

      /* Area C 3 colonne: centro testi, dx QrCode. Per ora funziona solo se !== VIP*/
      if (ticket.codeFamily === CodeFamily.DIF && ticket.additionalInfoExternal?.customFieldsExternal?.voucher?.voucherQr) {
        this.insertDifVoucher(ticket);
      } else if (ticket.codeFamily !== CodeFamily.VIP_CARD && ticket.codeFamily !== CodeFamily.BATT_VOLO && ticket.codeFamily !== CodeFamily.PARK) {
        this.insertQRCode(ticket, i);
      } else if (ticket.externalCode) {
        this.createBarCode(ticket);
      }

      /** Additional image management (GESTIONE PAGINE DOPO LA PRIMA) */
      switch (ticket.codeFamily) {
        // case CodeFamily.VIP_LOUNGE:
        //   await this.manageAdditionalMedia('HSL_TRK_IMG');
        // break;
        // case CodeFamily.PARK:
        //   await this.manageAdditionalMedia('PARKING_TICKET_MAP', 300);
        //   await this.manageAdditionalMedia('PARKING_NO_TELEPASS', 300);
        // break;
        case CodeFamily.VIP_LOUNGE:
        case CodeFamily.PARK:
          await this.manageAdditionalMedia(ticket, 300);
        break;
      }

      /* BANNER PIE PAGINA */
      if (banner_pie) {
        this.pdf.content.push({
          text: '',
          margin: [this.xMargin, 0, this.xMargin, 50],
          style: 'text',
        });
        this.pdf.content.push({ image: banner_pie, fit: [500, 80], margin: [0, 0, 0, 0], alignment: 'center' });
      }

      /* Gestione interruzione pagina*/
      this.insertBrakePage(i);

      /** ----------------------------- FINE MODALITA ANDREA + EROS -----------------------------*/

    }

    /* CREAZIONE PDF */
    this.createPdf(this.pdf);

    this.ticketSub.unsubscribe();
    this.ticketSub = null;

  }

  private createBarCode(ticket: Ticket) {

    const canvas = document.createElement("canvas");

    let barcode: string;

    if (ticket.externalCode) {
      this.suffixName = ticket.externalCode;
      if (ticket.additionalInfoProduct.externalTicketType == BarcCodeType.PDF417) {
        barcode = PDF417.draw(ticket.externalCode, canvas, 4, 1, 30);
      } else {
        barcode = JsBarcode(canvas, ticket.externalCode, { height: 100, format: ["EAN13"] });
      }
    }

    const buf = canvas.toDataURL("image/png");

    const detailAttribute = "";

    const dateFrom = new Date(ticket.validityFrom);
    const dateHourFromString = dateFrom.toLocaleDateString(this.locale, this.timezone) + " - " + dateFrom.toLocaleTimeString(this.locale, this.timezone);
    const dateTo = new Date(ticket.validityTo);
    const dateHourToString = dateTo.toLocaleDateString(this.locale, this.timezone) + " - " + dateTo.toLocaleTimeString(this.locale, this.timezone);

    const covered = this.coveredPipe.transform(ticket?.additionalInfoExternal?.customFieldsExternal?.uncoverd);

    this.pdf.content.push({
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          table : {
            body: [
              [{ text: [this.productsStrings[this.translate.currentLang].generic.ingresso_singolo + " " + ticket.name + " " +  covered, detailAttribute] }],
              [{ text: [this.productsStrings[this.translate.currentLang].generic.no_telepass], style: 'bold' }]
            ],
          },
          alignment: 'center',
          margin: [0, 40],
          style: 'text',
          layout: 'noBorders'
        },
        {
          width: 'auto',
          table: {
            heights: [20],
            widths: [150],
            body: [
              //  ['', { text: 'Biglietto: ' + ticket.shortCode, alignment: 'center', style: 'text' }],
              [{ text: this.productsStrings[this.translate.currentLang].generic.biglietto + ticket.externalCode, alignment: 'center', style: 'text' }],
              [{ text: this.productsStrings[this.translate.currentLang].generic.validFrom + " " + dateHourFromString + " " + this.productsStrings[this.translate.currentLang].generic.to + " " + dateHourToString, alignment: 'center', margin: [0, 0], style: 'text' }],
              //  [{ text: ['Ingresso singolo - ' + ticket.name, detailAttribute], alignment: 'center', margin: [0, 40], style: 'text' }, { qr: ticket.code, margin: [0, 0], alignment: 'center', fit: '130' }]
              [{ image: buf, width: 150, margin: [0, 0, 0, 0], alignment: 'center' }],
            ],
          },
          margin: [this.xMargin, 0],
          layout: 'noBorders'
        }
      ]
    });

  }

  private imageFromBlob(blob) {

    const sub = new Subject<string>();

    const reader = new FileReader();
    
    reader.readAsDataURL(blob);

    reader.onload = () => {
        const content: string = reader.result as string;
        sub.next(content);
        sub.complete();
    };

    reader.onerror = () => {
      sub.next(null);
        sub.complete();
    };

    return sub.asObservable();

  }

  private getProductImage(itemCode: string, keyAttribute: string) {

    const params: IAttributeInfoFromItemParams = {
      permalink: 'sacbo',
      itemCode,
      lang: this.translate.currentLang,
      keyAttribute
    };

    return this.mediaApiService.imageFromItem(params).pipe(
      map(img => {

        return img;

      }, error => {

        return null;

      })
    );

  }

  private getBannerAndCreatePdf() {
    this.ui.showSpinner();

    this.mediaApiService.getRandomBanner(this.translate.currentLang).subscribe(banner => {

      const reader = new FileReader();
      
      reader.readAsDataURL(banner);

      reader.onloadend = async () => {
  
        const result = reader.result;
  
        if (result) {
          await this.constructPdf(result.toString());
        }
        
      };

      reader.onerror = async () => {
        await this.constructPdf(null);
      };

    }, async error => {

      console.log("ERR: ", error);
      await this.constructPdf(null);

    });

  }

  private createPdf(pdf: any) {
    const pdfDocGenerator = pdfMake.createPdf(pdf);

    pdfDocGenerator.getBlob((blob) => {
      const fileURL = URL.createObjectURL(blob);
      this.ui.closeSpinner();
      this.downloadPDF(fileURL);
    });
  }

  insertBrakePage(i) {
    this.pdf.content.push({
      text: '',
      margin: [this.xMargin, 0, this.xMargin, 40],
      style: 'text',
      pageBreak: i !== (this.ticketListLenght - 1) ? 'after' : '',
    });
  }

  insertRichiestaInfo(preTextParagraph, addTextInfo, postTextParagraph) {
    // PRIMA RIGA
      this.pdf.content.push({
        text: [
          preTextParagraph
        ],
        margin: [this.xMargin, 0, this.xMargin, 10],
        style: 'text',
      });
    // SECONDA RIGA
      this.pdf.content.push({
        text: [
          this.productsStrings[this.translate.currentLang].generic.bottom_text_contact,
          {
            text: 'link' + addTextInfo,
            style: 'link',
            link: environment.marketPlace + 'settings/support'
          }
        ],
        margin: [this.xMargin, 0, this.xMargin, 10],
        style: 'text',
      });
    // TERZA RIGA
      this.pdf.content.push({
        text: [
          postTextParagraph
        ],
        margin: [this.xMargin, 0, this.xMargin, 10],
        style: 'text',
      });
  }

  insertDifVoucher(ticket: Ticket) {
    const str = this.productsStrings[this.translate.currentLang];
    const dif = ticket.additionalInfoExternal?.customFieldsExternal;
    const day = (d?: string) => (d ?? '').split('-').reverse().join('/'); // YYYY-MM-DD -> dd/MM/yyyy, no timezone
    const sizes = Object.entries((dif?.sizes ?? {}) as Record<string, number>)
      .filter(([, n]) => n > 0)
      .map(([code, n]) => (str.DIF['size_' + code] ?? code) + ': ' + n);
    this.suffixName = ticket.externalCode;
    this.pdf.content.push({
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          table: {
            heights: [20, 20],
            widths: [200, 150],
            body: [
              ['', { text: str.generic.biglietto + ticket.externalCode, alignment: 'center', style: 'text' }],
              ['', { text: str.DIF.dal + ' ' + day(dif?.startDate) + ' ' + str.DIF.al + ' ' + day(dif?.endDate), alignment: 'center', margin: [0, 0], style: 'text' }],
              [{ text: sizes.join('\n'), alignment: 'center', margin: [0, 40], style: 'text' }, { qr: dif?.voucher?.voucherQr, margin: [0, 0], alignment: 'center', fit: '130' }],
            ],
          },
          margin: [this.xMargin, 0],
          layout: 'noBorders',
        }
      ]
    });
  }

  insertQRCode(ticket: Ticket, i: number) {
    this.suffixName = ticket.shortCode;
    let detailAttribute = '';
    let ticketName: string[] = [];
    if (ticket.codeFamily !== CodeFamily.BGY_TOP) {
      detailAttribute = " " + this.productsStrings[this.translate.currentLang].generic.biglietto + ticket.additionalInfo?.attribute?.[0]?.name;
    }

    if (ticket.codeFamily != CodeFamily.PORTERAGGIO) {
      ticketName = [this.productsStrings[this.translate.currentLang].generic.ingresso_singolo + " " + ticket.name, detailAttribute];
    }


    this.pdf.content.push({
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          table: {
            heights: [20, 20],
            widths: [200, 150],
            body: [
              ['', { text: this.productsStrings[this.translate.currentLang].generic.biglietto + ticket.shortCode, alignment: 'center', style: 'text' }],
              ['', { text: this.productsStrings[this.translate.currentLang].generic.validFrom + " " + new Date(ticket.validityFrom).toLocaleDateString(this.locale, this.timezone) + " " + this.productsStrings[this.translate.currentLang].generic.to + " " + new Date(ticket.validityTo).toLocaleDateString(this.locale, this.timezone), alignment: 'center', margin: [0, 0], style: 'text' }],
              [{ text: ticketName, alignment: 'center', margin: [0, 40], style: 'text' }, { qr: ticket.code, margin: [0, 0], alignment: 'center', fit: '130' }],
            ],
          },
          margin: [this.xMargin, 0],
          layout: 'noBorders',
        }
      ]
    }
    );
  }

  insert2ColsData(ticket: Ticket, i, img2Cols, viewPassengers, viewTypeCard): void {

    // Gestione dei passeggeri - Caso per BGY TOP
    // [SCBMP-T755] La data del servizio non si stampa se non è stata chiesta all'utente (flag assente = BE precedente: si stampa come prima)
    const date = new Date(ticket.additionalInfoProduct?.bookDateRequested !== false ? ticket.additionalInfo?.date : undefined);

    const bgyData: any[] = [];
    if (viewPassengers) {
      for (const attr of ticket.additionalInfo.attribute) {
        if (attr.quantity > 0) {
          bgyData.push(attr.name + ' ' + attr.quantity);
        }
      }
    }
    // FINE Gestione dei passeggeri

          // Cestione porteraggio

          if (ticket.codeFamily == CodeFamily.PORTERAGGIO && ticket.additionalInfo.porterageData) {

            const marginLeft = 20;
    
            this.pdf.content.push({ text: `${ ticket.additionalInfo.porterageData.name } ${ ticket.additionalInfo.porterageData.surname }`, margin: [marginLeft, 0, 0, 0], alignment: 'left', style: 'text' });
            this.pdf.content.push({ text: `${ ticket.additionalInfo.porterageData.phone }`, margin: [marginLeft, 0, 0, 0], alignment: 'left', style: 'text' });
            this.pdf.content.push({ text: `${ ticket.additionalInfo.porterageData.email }`, margin: [marginLeft, 0, 0, 0], alignment: 'left', style: 'text' });
            this.pdf.content.push({ text: `${ new Date(+ticket.additionalInfo.porterageData.flightDate).toLocaleDateString(this.locale, this.timezone) }`, margin: [marginLeft, 0, 0, 0], alignment: 'left', style: 'text' });
            this.pdf.content.push({ text: `${ ticket.additionalInfo.porterageData.flightNumber }`, margin: [marginLeft, 0, 0, 0], alignment: 'left', style: 'text' });
    
            ticket.additionalInfo.porterageData.details.filter(detail => detail.quantity).forEach(detail => {
    
              this.pdf.content.push({ text: `${ detail.quantity }x ${ this.translate.instant('porteraggio.'+ detail.code) }`, margin: [marginLeft, 0, 0, 0], alignment: 'left', style: 'text' });
    
            })
    
          }
    

    // Gestione dei dati del luogo di spedizione
    const spedizioneData: any[] = [];
    if (ticket.additionalInfo.withdrawalData !== undefined) {
      spedizioneData.push(this.productsStrings[this.translate.currentLang].generic.citta + ticket.additionalInfo.withdrawalData.city);
      spedizioneData.push(this.productsStrings[this.translate.currentLang].generic.provincia + ticket.additionalInfo.withdrawalData.province);
      spedizioneData.push(this.productsStrings[this.translate.currentLang].generic.cap + ticket.additionalInfo.withdrawalData.zipCode);
      spedizioneData.push(this.productsStrings[this.translate.currentLang].generic.indirizzo + ticket.additionalInfo.withdrawalData.address);
    }
    // FINE Gestione dei dati del luogo di spedizione
    
      this.pdf.content.push({
        table: {
          widths: ['*', 'auto'],
          body: [
            [
              {
                ul: [
                  // 'Intestatario tessera: '
                  this.existValue(this.productsStrings[this.translate.currentLang].generic.intestatario_card, ticket.additionalInfo.accountHolder),
                  // 'Tipo Card:'
                  this.existValueThenText(this.productsStrings[this.translate.currentLang].generic.tipo_card, viewTypeCard, ticket.additionalInfo?.attribute?.[0]?.name),
                  // 'Luogo spedizione:'
                  this.existValueThenText(this.productsStrings[this.translate.currentLang].generic.luogo_spedizione, ticket.additionalInfo.withdrawalData, ''),
                  {
                    ul: spedizioneData,
                    type: 'circle',
                  },
                  // 'Gruppo: '
                  this.existValue(this.productsStrings[this.translate.currentLang].generic.gruppo, ticket.additionalInfo.nameLeader),
                  // 'Numero volo: '
                  this.existValue(this.productsStrings[this.translate.currentLang].generic.numero_volo, ticket.additionalInfo.flight),
                  // 'Data richiesta per il servizio: '
                  this.existValueDate(this.productsStrings[this.translate.currentLang].generic.data_richiesta_servizio, date , date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()),
                   // 'Compagnia aerea: '
                   this.existValue(this.productsStrings[this.translate.currentLang].generic.airline, ticket.additionalInfo.airline),
                   // 'Destinazione: '
                   this.existValue(this.productsStrings[this.translate.currentLang].generic.destination, ticket.additionalInfo.destination),
                   // 'Numero di passeggeri:'
                  this.existValueThenText(this.productsStrings[this.translate.currentLang].generic.numero_passeggeri, viewPassengers, ''),
                  {
                    ul: bgyData,
                    type: 'circle',
                  }
                ],
                style: 'text'
              },
              this.existValueImg(img2Cols) // Eventuale immagine nella colonna di destra. 
            ],
          ],
        },
        layout: 'noBorders',
        margin: [this.xMargin, 0],
      }

      );
    }

    // Stampa o meno traduzione e valore di una data chiave
  existValue(text, value) {
    if (value === undefined) {
      return '';
    } else {
      return text + value;
    }
  }

  // Stampa o meno traduzione e valore specifico di una data chiave
  existValueThenText(text, value, valuePrinted) {
    if (value === undefined || value === false) {
      return '';
    } else {
      return text + valuePrinted;
    }
  }

  // Stampa o meno traduzione e data di una chiave
  existValueDate(text, valueDate, valuePrinted) {
    if (valueDate instanceof Date && !isNaN(valueDate.getMonth())) {
      return text + valuePrinted;
    } else {
      return '';
    }
  }

  // Stampa o meno immagine di una data chiave
  existValueImg(img) {
    if (img === undefined || img === '' || img === '') {
      return {
        style: 'text',
        text: '',
        width: 200,
        margin: [this.xMargin, 0]
      };
    } else {
      return {
        image: img,
        width: 200,
        margin: [this.xMargin, 0]
      };
    }
  }

  // ---------- PRIVATE METHODS ---------- //

  /** Method that download and reads a specific media through its language and filters */
  private async readMedia(language: string, filters?: MediaFilters, mediaURL?: string): Promise<string | ArrayBuffer> {
    let result: string | ArrayBuffer;

    await new Promise (async (res, rej) => {
      const media = mediaURL ? await fetch(mediaURL).then(r => r.blob()) : await this.mediaApiService.getMedia(language, filters).toPromise();

      const reader = new FileReader();

      reader.readAsDataURL(media);

      reader.onloadend = () => {
        result = reader.result;
        res(null);
      }
    });

    return result ? result : '';
  }

  /** Memoized wrapper around readMedia for static, per-language PDF assets (header/VIP card/battery) */
  private readMediaCached(language: string, filters: MediaFilters): Promise<string | ArrayBuffer> {
    const cacheKey = `${language}:${filters.key}`;

    if (!this.staticMediaCache.has(cacheKey)) {
      const promise = this.readMedia(language, filters).catch(err => {
        this.staticMediaCache.delete(cacheKey);
        throw err;
      });
      this.staticMediaCache.set(cacheKey, promise);
    }

    return this.staticMediaCache.get(cacheKey);
  }

  /** Method that adds additional media required in certain tickets (at the moment maps for VIP LOUNGE and PARKING products) */
  private async manageAdditionalMedia(ticket: Ticket, customWidth?: number): Promise<void> {
    const productImgs: string[] = this.commonService.getProductSpecificImages(ticket.additionalInfoProduct, TranslationAttributeImageKey.PDF_IMG_PRODUCT);

    /** Family images has to be retrieved from family details, meaning product info are firstly required */
    const familyImgs: string[] = await new Promise((res, rej) => {
      this.productService.getProductsInfo([+ticket.additionalInfoProduct.id]).subscribe(async response => {
        const productInfo = response.data[0];
        const imgs = await this.commonService.getProductFamilySpecificImages(productInfo.idProductFamily, TranslationAttributeImageKey.PDF_IMG_FAMILY);
        res(imgs);
      }, _ => {
        rej([]);
      });
    })

    if (productImgs.length) {
      await this.addAllMediaToPdf(productImgs, customWidth);
    }

    if (familyImgs.length) {
      await this.addAllMediaToPdf(familyImgs, customWidth);
    }
  }

  /** Method that downloads the PDF file without opening a visualization tab (and avoiding issues on Safari and mobile browsers) */
  downloadPDF(fileUrl: string, title: string = 'SACBO - ticket_' + this.suffixName): void {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.href = fileUrl;
    a.download = title;
    a.click();
    document.body.removeChild(a);
  }

  // ---------- PRIVATE METHODS --------- //

  private async addAllMediaToPdf(mediaList: string[], customWidth?: number): Promise<void> {
    await Promise.all(mediaList.map(async img => {
      const image = await this.readMedia(this.translate.currentLang, null, img);
      this.pdf.content.push({
        image,
        width: customWidth ? customWidth : 400,
        margin: [0, 0, this.xMargin, 20],
        alignment: 'center'
      });
    }));
  }
}
